import styled, { StyledProps } from 'styled-components'
import { IGridColProps } from '@ucheba/ui/components/Grid/types'
import { IPropAs, IPropWidth } from '@ucheba/utils/helpers/components/prop.types'
import { IBoxProps } from '@ucheba/ui/components/Box/types'

const TeachersListItem = styled.div<StyledProps<IPropWidth>>`
  display: flex;
  flex-direction: column;
  box-sizing: content-box;
  flex-shrink: 0;
  overflow: hidden;
  width: ${(props) => props.width || '100%'};
  box-shadow: 0 2px 5px 0 rgba(3, 15, 35, 0.15);
`

const StyledGridCol = styled.div<StyledProps<IGridColProps | IPropAs>>`
  display: flex;
  align-items: center;
`

const StyledBox = styled.div<StyledProps<IBoxProps | IPropAs>>`
  height: 100%;
`

const VideoPreviewOverlay = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
`

const VideoPreviewExperienceText = styled.div``

const VideoPreviewAverageScoreText = styled.div``

const BlockWithGradient = styled.div`
  position: absolute;
  width: 100%;
  min-height: 144px;
  bottom: 0;
  background: linear-gradient(to bottom, rgba(4, 3, 5, 0), #040305 86%, #040305 100%);
  z-index: -1;
`

export default {
  TeachersListItem,
  StyledGridCol,
  StyledBox,
  VideoPreviewOverlay,
  VideoPreviewAverageScoreText,
  VideoPreviewExperienceText,
  BlockWithGradient,
}
